<template>
  <span
    class="tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-full tw-border tw-border-emerald-200 tw-bg-emerald-50 tw-px-2.5 tw-py-1 tw-text-xs tw-font-semibold tw-text-emerald-700"
  >
    <outline-icon name="shield-check" size="sm" />
    {{ $l('verifiedPrice') }}
  </span>
</template>

<script>
import OutlineIcon from './OutlineIcon.vue';

export default {
  name: 'VerifiedPriceBadge',
  components: {
    OutlineIcon,
  },
};
</script>
